import { getAuthAxiosBackend } from "../../helpers/axios"

class MartyrServices{

    get(id){
        return getAuthAxiosBackend().get('tasdeed/martyrs/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('tasdeed/martyrs', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('tasdeed/martyrs/' + id)
    }
}

export default new MartyrServices()